// client/src/coms/views/chatview_parts/ChatLiveStatus.js
// Thin status line above the composer: who is typing, stream reconnect state, and send failures.
import React from 'react';
import { typingLabel } from './chatRealtime';

export default function ChatLiveStatus({ typingState, streamStatus, sendErr, onDismissSendErr, isShellMobile }) {
  const typing = typingLabel(typingState);
  const reconnecting = streamStatus === 'reconnecting';

  if (!typing && !reconnecting && !sendErr) return null;

  return (
    <div
      className="vox-chat-live-status"
      role="status"
      aria-live="polite"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        padding: isShellMobile ? '2px 12px' : '2px 16px',
        fontSize: 12,
        lineHeight: '16px',
        minHeight: 16,
      }}
    >
      {sendErr ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#ff8a8a', fontWeight: 600 }}>
          <span style={{ minWidth: 0 }}>{sendErr}</span>
          {typeof onDismissSendErr === 'function' ? (
            <button
              type="button"
              onClick={onDismissSendErr}
              aria-label="Dismiss"
              style={{
                background: 'transparent',
                border: 0,
                color: 'rgba(var(--vx-fg-rgb, 255,255,255), calc(0.7 * var(--vx-ov, 1)))',
                cursor: 'pointer',
                padding: 0,
                fontSize: 14,
                lineHeight: 1,
              }}
            >
              ×
            </button>
          ) : null}
        </div>
      ) : null}
      {reconnecting ? (
        <div style={{ color: 'rgba(255,200,120,0.95)', fontWeight: 600 }}>Reconnecting… new messages will appear when the connection is back.</div>
      ) : null}
      {typing ? <div style={{ color: 'rgba(var(--vx-fg-rgb, 255,255,255), calc(0.72 * var(--vx-ov, 1)))', fontStyle: 'italic' }}>{typing}</div> : null}
    </div>
  );
}
